import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { GlobalService } from 'src/app/_services/global.service';
import { UserService } from 'src/app/_services/user.service';
import { Observable, Observer, fromEvent, merge, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackBarErrorComponent } from '../snack-bar-error/snack-bar-error.component';
import { SnackbarService } from 'src/app/_services/snackBar.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {
  forgotForm: UntypedFormGroup;
  userNotExist = false;
  emailSent = false;
  currLang;
  onLine;

  constructor(private userService: UserService,
    private snackBar: SnackbarService,
    private _snackBar: MatSnackBar,
    private global: GlobalService,
    private translate: TranslateService) {
    this.global.getLang().subscribe(res => {
      this.currLang = res
    })

  }

  ngOnInit(): void {
    this.forgotForm = new UntypedFormGroup({
      email: new UntypedFormControl('', [Validators.required, Validators.email, Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$')]),
    })
    this.createOnline$().subscribe(isOnline => {
      this.onLine = isOnline;
    });
  }

  createOnline$() {
    return merge<any>(
      fromEvent(window, 'offline').pipe(map(() => false)),
      fromEvent(window, 'online').pipe(map(() => true)),
      new Observable((sub: Observer<boolean>) => {
        sub.next(navigator.onLine);
        sub.complete();
      }));
  }

  getValidationMessage(control: string) {
    let errorMsg;
    if (this.forgotForm.controls[control].errors) {
      const fieldName = this.translate.instant('forget-password.' + control);
      const requiredText = this.translate.instant('forget-password.required');
      const invalidText = this.translate.instant('forget-password.invalid');
      const notFoundText = this.translate.instant('forget-password.not-found-text');
      errorMsg = this.forgotForm.controls[control].errors.required ? `${fieldName + requiredText}`
        : ` ${this.userNotExist ? `${notFoundText}` : `${fieldName + invalidText}`}`
    }
    return errorMsg;
  }

  sendHandler() {
    this.userService.sendResetPasswordEmail({ email: this.forgotForm.value['email'] }).subscribe(res => {
      this.userNotExist = false;
      this.emailSent = true;
    },
      err => {
        if (!this.onLine) {
          this.snackBar.setSnackBarMessage(this.translate.instant('login.connection-error'));
          this._snackBar.openFromComponent(SnackBarErrorComponent, {
            duration: 5000,
            horizontalPosition: 'center',
            verticalPosition: 'top',
          });
        }
        else {
          this.userNotExist = true;
          this.forgotForm.controls['email'].setErrors({ 'incorrect': true });
          this.forgotForm.controls['email'].markAsTouched();
        }
      })
  }
}
